import React from "react"
import bgImg from "@images/2022/p3/12-100.jpg"
import iconHeImg from "@images/2022/p3/13.png"
import iconHandImg from "@images/2022/p3/14.png"
import iconFaceImg from "@images/2022/p3/15.png"
import { animated } from "@react-spring/web"
import createPage from "@src/components/page"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { byToday, parseDate } from "@src/utils/data-parser"
import * as styles from "./pageJoin.module.scss"

const parseData = (data) => {
  const parsed = {
    created: {
      ...parseDate(),
    },
    total: "0000",
  }
  try {
    const createdStr = data.user.attributes["created-at"]
    parsed.created = parseDate(createdStr)
    parsed.total = byToday(createdStr)
  } catch (e) {}
  return parsed
}

const PageJoin = createPage(
  ({ data, offset }) => {
    const parsedData = parseData(data)
    const anime1Styles = useEnteringTrail(3, offset, { type: "mb" })
    const anime2Styles = useEnteringTrail(2, offset, { step: 0.4 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.8 })
    return (
      <>
        <div>
          <div className="iconsGroup">
            <div>
              <animated.img
                src={iconHeImg}
                className={styles.iconHe}
                style={anime1Styles[0]}
              />
              <animated.img
                src={iconFaceImg}
                className={styles.iconFace}
                style={anime1Styles[1]}
              />
              <animated.img
                src={iconHandImg}
                className={styles.iconHand}
                style={anime1Styles[2]}
              />
            </div>
          </div>
        </div>
        <div>
          <animated.p style={anime2Styles[0]}>
            <span className="gColor">{parsedData.created.year}</span>年
            <span className="gColor">{parsedData.created.month}</span>月
            <span className="gColor">{parsedData.created.date}</span>日<br />
            {callYou(data)}来到机核
          </animated.p>
          <animated.p style={anime2Styles[1]}>
            感谢与{callYou(data)}同行的
            <span className="gColor">{parsedData.total}</span>天
          </animated.p>
        </div>

        <animated.div className="bottomText" style={anime3Styles[0]}>
          机核上线于 2010 年 5 月 12 日
          <br />至 2023 年 1 月 1 日，已运营 4617 天
        </animated.div>
      </>
    )
  },
  {
    className: "pageLayout1",
  }
)

export const pageJoinData = {
  key: "join",
  bgImg,
  Page: PageJoin,
}

export default PageJoin
